<template>
    <div class="container">
        <h1>Colyseus tester</h1>

        <div>
            <div class="btn btn-success" v-on:click="create1234">Create (1234)</div>
            <div class="btn btn-success" v-on:click="join1234">Join (1234)</div>
            <div class="btn btn-success" v-on:click="join4321">Join (4321) </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'colyseus-tester',
        data() {
            return {
                wsUrl: 'ws://127.0.0.1:2675',
            };
        },
        methods: {
            create1234() {
                this.$gameClient.setUrl(this.wsUrl);

                console.log('JoinOrCreateRoom ' + 1234 + '..');

                this.$gameClient.joinOrCreateRoom(1234).then((room) => {
                    console.log('then', room);
                }).catch((err) => {
                    console.log('err', err);
                });
            },
            join1234() {
                this.$gameClient.setUrl(this.wsUrl);

                console.log('JoinRoom ' + 1234 + '..');

                this.$gameClient.joinRoom(1234).then((room) => {
                    console.log('then', room);
                }).catch((err) => {
                    console.log('err', err);
                })
            },
            join4321() {
                this.$gameClient.setUrl(this.wsUrl);

                console.log('JoinRoom ' + 4321 + '..');

                this.$gameClient.joinRoom(4321).then((room) => {
                    console.log('then', room);
                }).catch((err) => {
                    console.log('err', err);
                })
            }
        }
    }
</script>